<template>
  <div ref="element" :class="$style.positionable" :style="style">
    <slot></slot>
  </div>
</template>

<script>
import mountedMixin from '@/components/mountedMixin';
import sizeMixin from '@/components/sizeMixin';

export default {
  name: 'Positionable',

  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },

  mixins: [mountedMixin, sizeMixin],

  computed: {
    style() {
      return {
        transform: `translateX(${this.x}px) translateY(${this.y}px)`,
      };
    },
  },
};
</script>

<style lang="scss" module>
.positionable {
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Positionable.vue